import { Badge, Card, CardMedia, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import { get_all_packages_list } from "../../../actions/packages_actions"
import './packages.css'


export const PackCategoryCard = ({category, clickFilter}) => {
	const [count, set_count] = useState(0)

	useEffect(()=>{
		get_all_packages_list(1, '', category.tag)
		.then(res=>set_count(res?.count))
		// .catch(e=>dispatch(post_short_alert_message({error:e.message})))
	}, [category.tag])

    return (
        <Card className={"card click_card"} onClick={e=>{
            clickFilter()
            window.scrollTo({top: document.getElementById("packages").offsetTop - 79, behavior:'smooth'})
            }}>
            <CardMedia className="media" image={category.image} />
            <div className={"overlay"}>
                <Typography variant="body2"> 
                    {category.title}
                </Typography>
            </div>
                <Typography className="overlay2" variant="body1" ><Badge color="warning" badgeContent={count}></Badge></Typography>
        </Card>
    )
}



/* <Grid item xs={11} sm={6}>
								<Card className={"card click_card"} onClick={e=>{
									setSearchTags(['advantures'])
									set_load(true)						
									get_packages_counts(['adventures'], 1).then(res=>setLists(res)).finally(()=>set_load(false))
									window.scrollTo({top: document.getElementById("packages").offsetTop - 79, behavior:'smooth'})

									}}>
									<CardMedia className="media" image={adventure} />
									<div className={"overlay"}>
										<Typography variant="h6"> Adventures </Typography>
										<Typography variant="body2" > {pack?.cost?.type} </Typography>
									</div>
									<Typography className="overlay2" variant="h6" > {adventures_count} </Typography>
								</Card>
							</Grid>
							{
								more_categories &&
								<Grid item xs={11} sm={6} >
								<Card className={"card click_card"} onClick={e=>{
									setSearchTags(['vacations'])
									set_load(true)						
									get_packages_counts(['vacations'], 1).then(res=>setLists(res)).finally(()=>set_load(false))
									window.scrollTo({top: document.getElementById("packages").offsetTop - 79, behavior:'smooth'})

									}}>
									<CardMedia className="media" image={vacay} />
									<div className={"overlay"}>
										<Typography variant="h6"> Vacations </Typography>
										{/* <Typography variant="body2" > {pack?.cost?.type} </Typography>
									</div>
									<Typography className="overlay2" variant="h6" > {vacations_count} </Typography>
								</Card>
							</Grid>
							}
							{
								more_categories &&

									<Grid item xs={11} sm={6} >
										<Card className={"card click_card"} onClick={e=>{
											setSearchTags(['wild'])
											set_load(true)						
											get_packages_counts(['wild'], 1).then(res=>setLists(res)).finally(()=>set_load(false))
											window.scrollTo({top: document.getElementById("packages").offsetTop - 79, behavior:'smooth'})

											}}>
											<CardMedia className="media" image={wild} />
											<div className={"overlay"}>
												<Typography variant="h6"> Wild Tours </Typography>
												{/* <Typography variant="body2" > {pack?.cost?.type} </Typography>
											</div>
											<Typography className="overlay2" variant="h6" > {vacations_count} </Typography>
										</Card>
									</Grid>}
									{
								more_categories &&
									<Grid item xs={11} sm={6} >
										<Card className={"card click_card"} onClick={e=>{
											setSearchTags(['coast'])
											set_load(true)						
											get_packages_counts(['coast'], 1).then(res=>setLists(res)).finally(()=>set_load(false))
											window.scrollTo({top: document.getElementById("packages").offsetTop - 79, behavior:'smooth'})

											}}>
											<CardMedia className="media" image={coast} />
											<div className={"overlay"}>
												<Typography variant="h6"> Coastal </Typography>
												{/* <Typography variant="body2" > {pack?.cost?.type} </Typography>
											</div>
											<Typography className="overlay2" variant="h6" > {vacations_count} </Typography>
										</Card>
									</Grid>}
									{
								more_categories &&
									<Grid item xs={11} sm={6} >
										<Card className={"card click_card"} onClick={e=>{
											setSearchTags(['day tours'])
											set_load(true)						
											get_packages_counts(['day tours'], 1).then(res=>setLists(res)).finally(()=>set_load(false))
											window.scrollTo({top: document.getElementById("packages").offsetTop - 79, behavior:'smooth'})

											}}>
											<CardMedia className="media" image={dayvisit} />
											<div className={"overlay"}>
												<Typography variant="h6"> Single Day Tours </Typography>
												{/* <Typography variant="body2" > {pack?.cost?.type} </Typography>
											</div>
											<Typography className="overlay2" variant="h6" > {vacations_count} </Typography>
										</Card>
									</Grid>

							} */
